import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, Tooltip} from '@chakra-ui/react'
import i18next from 'i18next'
import {useTranslation} from 'react-i18next'
import {SolidWarningIcon} from '../../../icons'
import {hasMissingPayeeDetails} from '../payeeDetails'

const PayeeWithReferenceCell = ({row}) => {
  i18next.loadNamespaces('pointsOnPayments')
  const {t} = useTranslation('pointsOnPayments')
  const {payeeName, billNumber, payee} = row.original
  const detailsMissing = hasMissingPayeeDetails(payee)

  if (!detailsMissing) {
    return (
      <Flex direction="column" minWidth="0">
        <Text
          className="fs-mask"
          fontWeight="500"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {payeeName}
        </Text>
        {billNumber && (
          <Text color="mld.neutral.700">
            {t('bill.table.referenceLabel', {billNumber})}
          </Text>
        )}
      </Flex>
    )
  }

  return (
    <Tooltip
      className="fs-unmask"
      label={t('pointsOnPayments:bill.table.payeeMissingDetails.missing')}
      placement="top"
      hasArrow
    >
      <Flex
        direction="column"
        className="fs-mask"
        minWidth="0"
        cursor="default"
      >
        <Flex alignItems="center" gap="xxs" overflow="hidden">
          <Text
            color="mld.warning.900"
            fontWeight="500"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            minWidth="0"
          >
            {payeeName}
          </Text>
          <SolidWarningIcon
            boxSize="20px"
            color="mld.warning.700"
            mb="xxs"
            flexShrink={0}
          />
        </Flex>
        {billNumber && (
          <Text color="mld.neutral.700">
            {t('bill.table.referenceLabel', {billNumber})}
          </Text>
        )}
      </Flex>
    </Tooltip>
  )
}

PayeeWithReferenceCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      payeeName: PropTypes.string,
      billNumber: PropTypes.string,
      payee: PropTypes.shape({
        email: PropTypes.string,
        businessNumber: PropTypes.string,
        bankAccount: PropTypes.shape({
          bsb: PropTypes.string,
          accountNumber: PropTypes.string,
        }),
      }),
    }).isRequired,
  }).isRequired,
}

export default PayeeWithReferenceCell
